import { forwardRef, useMemo } from 'react';
import { closeSnackbar, CustomContentProps, SnackbarContent } from 'notistack';
import { RequiredActionOutput } from '@coverright/data-access/types/enrollment';
import { RequiredActionProps } from './types';
import * as React from 'react';
import { actionTypeMap } from './required-actions/action-type-map';

interface RequiredActionSnackProps extends CustomContentProps {
  requiredAction: RequiredActionOutput,
  onHide?: () => void,
}

export const RequiredActionSnack = forwardRef<HTMLDivElement, RequiredActionSnackProps>((props, ref) => {
  const {
    id,
    message,
    requiredAction,
    onHide,
    ...other
  } = props

  const itemProps: RequiredActionProps = useMemo(() => ({
    item: requiredAction,
    onResolved: () => closeSnackbar(id),
    onHide
  }), [id, requiredAction, onHide])

  const Component = actionTypeMap[requiredAction.type as keyof typeof actionTypeMap];

  const content = useMemo(() => {
    return Component ? <Component {...itemProps} /> : null
  }, [itemProps, Component])

  return (
    <SnackbarContent ref={ref} role="alert" >
      {content}
    </SnackbarContent>
  )
})





declare module 'notistack' {
  interface VariantOverrides {
    requiredAction: {
      requiredAction: RequiredActionOutput,
      onHide?: () => void,
    }
  }
}
